import { SkinDate } from "./skin-date"
import { ThesaurusTerm } from "./thesaurus-term"
import { TranslatedString } from "./translated-string"

export interface StateOfConservation {
    stateOfConservation: string | null,
    precision: TranslatedString | null
}

export interface Alteration {
    media: string | null,
    drawing: string,
    title: TranslatedString,
    precision: TranslatedString,
    typeOfAlteration: string, //ThesaurusTerm id
    detailedViews: string[],
}

export interface Signer {
    id: string
    signer: TranslatedString
    signature: string
}

export interface PredictedIntervention {
    typeIntervention: string | null,
    precision: TranslatedString | null
}

export interface ConditionReport {
    id: string
    associatedMedias: any
    conditionReportCS: {
        alterations: Alteration[],
        alterationDetails: DefectElement[] | null,
        referenceNumber: string,
        comments: any[],
        reportDate: SkinDate,
        signers?: Signer[],
        stateOfConservations?: StateOfConservation[],
        predictInterventions?: PredictedIntervention[],
        reportReason?: string,
    }
    workflowSchema?: any
}

export enum ConditionReportState {
    IN_PROGRESS = 'ui.lifecycle-state.inProgress',
    CLOSED = 'ui.lifecycle-state.validated',
}

export interface DefectAnnotation {
    id: number
    title: TranslatedString
    comments: TranslatedString[]
    media: string
    svg: string
}

export interface DefectAlteration {
    id: number
    typeOfAlteration: ThesaurusTerm['id']
    precision: TranslatedString
    annotations: DefectAnnotation[]
}

export interface DefectMaterial {
    id: number
    material: ThesaurusTerm['id']
    alterations: DefectAlteration[]
}

export interface DefectObservation {
    id: number
    typeOfObservation: ThesaurusTerm['id']
    materialAlterations: DefectMaterial[]
}

export interface DefectElement {
    id: number
    observationAlterationDetails: DefectObservation[]
    element: TranslatedString
    precision: TranslatedString
}